module.exports = __webpack_public_path__ + "static/media/loginbg.8cbf6c66.png";